// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load-more-btn[data-v-f5add222]{width:9.375rem;height:3.125rem;margin:0 auto;border-bottom:1px solid #d0d0d0;text-decoration:none;outline:none}@media only screen and (max-width: 959px){.load-more-btn[data-v-f5add222]{width:7.5rem;height:2.5rem}}", ""]);
// Exports
module.exports = exports;
